import Slider from '@ui/Slider/component'
import { isDesktop } from 'assets/core/js/common'
import type { SliderOptions } from '@ui/Slider/component'

export default function (): void {
  document.querySelectorAll('.cms__slider').forEach((el) => {
    const id = el.id

    const config: SliderOptions = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      navigation: {
        nextEl: `#${id}-next`,
        prevEl: `#${id}-prev`,
      },
      pagination: {
        el: `#${id}-pagination`,
      },
      loop: false,
      on: {
        resize: (slider) => {
          if (isDesktop()) {
            slider.update({
              slidesPerView: 3,
              slidesPerGroup: 3,
            })
          } else {
            slider.update({
              slidesPerView: 'auto',
              slidesPerGroup: 1,
            })
          }
        },
      },
    }

    Slider(`#${id}`, config)
  })
}
